import React from 'react';

import * as OPTIONS from "../option-fields";

import AccountNavigation from './account-navigation';
import UpsellBlock from '../components/upsell-block';
import LogoutButton from '../components/logout-button';
import PreferencesBlock from './preferences-block';
import TopPicks from '../components/top-picks';

const AccountPreferences = () => {

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--preferences'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Preferences</h1>

                    <PreferencesBlock />

                    <TopPicks origin="account" />
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.preferences_upsell} type="preferences-upsell" />
                </div>

            </div>
        </>
    );
};

export default AccountPreferences;
